import { isVarNotEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { ReactStateAsync, StateSetter } from '../Types/Types'
import { useStateAsync } from './useStateAsync'

export type StateAppender<T extends unknown> = {
    state: T[]
    setter: StateSetter<T[]>
    appender: (...itemsToAdd: Nullable<T>[]) => void
    getter: () => Promise<T[]>
    remover: (entry: T) => void
}

export const useStateAppender = <T extends unknown>(initialState: T[] | (() => T[])): StateAppender<T> => {
    const [state, setState, getState]: ReactStateAsync<T[]> = useStateAsync<T[]>(initialState)

    const stateAppender = (...itemsToAdd: Nullable<T>[]): void => {
        setState((currentState: T[]): T[] =>
            currentState.concat(itemsToAdd.filter((item: Nullable<T>): boolean => isVarNotEmpty(item)) as T[])
        )
    }

    const stateRemover = (entry: T): void => {
        setState((currentState: T[]): T[] => currentState.filter((item: T): boolean => item !== entry))
    }

    return {
        state,
        setter: setState,
        appender: stateAppender,
        getter: getState,
        remover: stateRemover
    }
}
